module.exports = __webpack_public_path__ + "static/media/Kalispell MT.9b3d71e7.jpeg";